var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser || _vm.$userInfo.isCustomerAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _vm.companySetting
            ? _c("article", { staticClass: "tile is-child box" }, [
                _c(
                  "div",
                  { staticClass: "columns is-flex is-align-items-center" },
                  [
                    _vm._m(0),
                    !_vm.hasError &&
                    _vm.showSavingStatus &&
                    !_vm.toastNotificationEnabled
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "column is-flex is-justify-content-flex-end is-align-items-center",
                          },
                          [
                            _vm.saving
                              ? _c("span", {
                                  staticClass: "button is-loading is-white",
                                  staticStyle: { height: "27px" },
                                })
                              : _c(
                                  "span",
                                  { staticClass: "text has-text-success" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mso mso-18px" },
                                      [_vm._v("check_circle")]
                                    ),
                                  ]
                                ),
                            _c(
                              "span",
                              {
                                staticClass: "is-size-6",
                                class: _vm.saving
                                  ? "has-text-warning"
                                  : "has-text-success",
                              },
                              [_vm._v(_vm._s(_vm.savingStatus))]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "field columns tile is-child pt-0" },
                  _vm._l(_vm.defaultNumbers, function (defaultNumber, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "column is-one-third pl-0 py-0",
                        class: {
                          "pr-0": index == _vm.defaultNumbers.length - 1,
                        },
                      },
                      [
                        _c("p", { staticClass: "label" }, [
                          _c("span", { staticClass: "title is-6" }, [
                            _vm._v(_vm._s(defaultNumber.title)),
                          ]),
                        ]),
                        _vm._l(
                          defaultNumber.defaultValue,
                          function (item, itemIndex) {
                            return _c(
                              "div",
                              {
                                key: itemIndex,
                                staticClass:
                                  "columns mb-0 is-flex is-align-items-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "column pb-2 is-one-quarter" },
                                  [
                                    _c("div", { staticClass: "label" }, [
                                      _vm._v(_vm._s(item.label)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "column pb-2 is-three-quarters",
                                  },
                                  [
                                    _c("div", { staticClass: "control" }, [
                                      item.type == "Value"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: item.value,
                                                expression: "item.value",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "input",
                                            attrs: { type: "number", min: "0" },
                                            domProps: { value: item.value },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "value",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value",
                                              },
                                            ],
                                            staticClass: "input",
                                            attrs: { type: "text" },
                                            domProps: { value: item.value },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "value",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "field columns tile is-child" }, [
                  _c("div", { staticClass: "column is-half pl-0 py-0" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        staticClass:
                          "columns mb-0 is-flex is-align-items-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "column is-half pb-2 label" },
                          [_vm._v("Next Cr. Return No")]
                        ),
                        _c("div", { staticClass: "column is-half pb-2" }, [
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.companySetting.returnValue,
                                  expression: "companySetting.returnValue",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "input",
                              attrs: { type: "number", min: "0" },
                              domProps: {
                                value: _vm.companySetting.returnValue,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.companySetting,
                                    "returnValue",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "columns is-flex is-align-items-center" },
                      [
                        _c("div", { staticClass: "column is-half label" }, [
                          _vm._v("Next Journal No"),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.companySetting.recurringPrefix,
                                  expression: "companySetting.recurringPrefix",
                                },
                              ],
                              staticClass: "input",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.companySetting.recurringPrefix,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.companySetting,
                                    "recurringPrefix",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "column is-half pr-0 py-0" }, [
                    _vm._m(2),
                    _c(
                      "div",
                      { staticClass: "columns is-flex is-align-items-center" },
                      [
                        _c(
                          "div",
                          { staticClass: "column is-half pb-2 label" },
                          [_vm._v("Next No")]
                        ),
                        _c("div", { staticClass: "column is-half pb-2" }, [
                          _c("div", { staticClass: "control" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.batchNo,
                                  expression: "batchNo",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "input",
                              attrs: { type: "number", min: "0" },
                              domProps: { value: _vm.batchNo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.batchNo = _vm._n($event.target.value)
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "field tile is-child" }, [
                  _vm._m(3),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("div", { staticClass: "column is-half label" }, [
                            _vm._v("G/L Acct-Collected"),
                          ]),
                          _c("div", { staticClass: "column is-half" }, [
                            _c("div", { staticClass: "control is-extended" }, [
                              _c(
                                "div",
                                { staticClass: "select is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.companySetting
                                              .gstCollectedAccount,
                                          expression:
                                            "companySetting.gstCollectedAccount",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.companySetting,
                                            "gstCollectedAccount",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "null",
                                            disabled: "",
                                          },
                                        },
                                        [_vm._v("Select")]
                                      ),
                                      _vm._l(
                                        _vm.atglAccounts,
                                        function (atglAccount, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: {
                                                value: atglAccount.account,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(atglAccount.account) +
                                                  " " +
                                                  _vm._s(atglAccount.name) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("div", { staticClass: "column is-half label" }, [
                            _vm._v("G/L Acct-Spent"),
                          ]),
                          _c("div", { staticClass: "column is-half" }, [
                            _c("div", { staticClass: "control is-extended" }, [
                              _c(
                                "div",
                                { staticClass: "select is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.companySetting.gstSpentAccount,
                                          expression:
                                            "companySetting.gstSpentAccount",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.companySetting,
                                            "gstSpentAccount",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "null",
                                            disabled: "",
                                          },
                                        },
                                        [_vm._v("Select")]
                                      ),
                                      _vm._l(
                                        _vm.atglAccounts,
                                        function (atglAccount, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: {
                                                value: atglAccount.account,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(atglAccount.account) +
                                                  " " +
                                                  _vm._s(atglAccount.name) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("div", { staticClass: "column is-half label" }, [
                            _vm._v("G/L Acct-With-Hd"),
                          ]),
                          _c("div", { staticClass: "column is-half" }, [
                            _c("div", { staticClass: "control is-extended" }, [
                              _c(
                                "div",
                                { staticClass: "select is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.companySetting.taxWhAccount,
                                          expression:
                                            "companySetting.taxWhAccount",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.companySetting,
                                            "taxWhAccount",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "null",
                                            disabled: "",
                                          },
                                        },
                                        [_vm._v("Select")]
                                      ),
                                      _vm._l(
                                        _vm.atglAccounts,
                                        function (atglAccount, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: {
                                                value: atglAccount.account,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(atglAccount.account) +
                                                  " " +
                                                  _vm._s(atglAccount.name) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("div", { staticClass: "column is-half label" }, [
                            _vm._v("Accounting Basis"),
                          ]),
                          _c("div", { staticClass: "column is-half" }, [
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.companySetting.gstBasis,
                                    expression: "companySetting.gstBasis",
                                  },
                                ],
                                staticClass: "input",
                                domProps: {
                                  value: _vm.companySetting.gstBasis,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.companySetting,
                                      "gstBasis",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("div", { staticClass: "column is-half label" }, [
                            _vm._v("Accounting Periods"),
                          ]),
                          _c("div", { staticClass: "column is-half" }, [
                            _c("div", { staticClass: "control is-extended" }, [
                              _c(
                                "div",
                                { staticClass: "select is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.companySetting.gstPeriod,
                                          expression:
                                            "companySetting.gstPeriod",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.companySetting,
                                            "gstPeriod",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "0", disabled: "" } },
                                        [_vm._v("Select")]
                                      ),
                                      _vm._l(
                                        _vm.gstPeriod,
                                        function (period, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: {
                                                value: period.period,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(period.label) + " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "columns is-flex is-align-items-center",
                        },
                        [
                          _c("label", { staticClass: "column is-half label" }, [
                            _vm._v("Previous Closing Date"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "column is-half" },
                            [
                              _c("v-date-picker", {
                                staticClass: "is-fullwidth",
                                attrs: {
                                  "is-dark": _vm.$theme.isDark,
                                  masks: _vm.formats,
                                  attributes: _vm.attrs,
                                  locale: _vm.$userInfo.locale,
                                  timezone: _vm.$filters.getIanaTimezone(),
                                },
                                on: { input: _vm.glCloseDateInputEvent },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({
                                        inputValue,
                                        inputEvents,
                                      }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "field has-addons mb-0",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "control is-expanded has-icons-left",
                                                },
                                                [
                                                  _c(
                                                    "input",
                                                    _vm._g(
                                                      {
                                                        staticClass: "input",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value: inputValue,
                                                        },
                                                      },
                                                      inputEvents
                                                    )
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "icon is-small is-left",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "mso mso-18px",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "calendar_month"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2877715408
                                ),
                                model: {
                                  value: _vm.glCloseDate,
                                  callback: function ($$v) {
                                    _vm.glCloseDate = $$v
                                  },
                                  expression: "glCloseDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field columns tile is-child" }, [
                  _c("div", { staticClass: "column is-half pl-0 py-0" }, [
                    _vm._m(4),
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-half label" }, [
                        _vm._v("External account type"),
                      ]),
                      _c("div", { staticClass: "column is-half" }, [
                        _c("div", { staticClass: "control is-extended" }, [
                          _c("div", { staticClass: "select is-fullwidth" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.companySetting.externalAccounting,
                                    expression:
                                      "companySetting.externalAccounting",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.companySetting,
                                      "externalAccounting",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "null", disabled: "" } },
                                  [_vm._v("Select")]
                                ),
                                _c("option", { attrs: { value: "NONE" } }, [
                                  _vm._v("None"),
                                ]),
                                _c("option", { attrs: { value: "MYOB" } }, [
                                  _vm._v("MYOB"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "MONEYWORKS" } },
                                  [_vm._v("MoneyWorks")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field tile is-child" }, [
                  _vm._m(5),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "columns" }, [
                        _c(
                          "div",
                          { staticClass: "column is-half label mb-0" },
                          [_vm._v("Print Ruler Line")]
                        ),
                        _c("div", { staticClass: "column is-half" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-curve p-smooth m-0 p-bigger",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.companySetting.shadow,
                                    expression: "companySetting.shadow",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.companySetting.shadow
                                  )
                                    ? _vm._i(_vm.companySetting.shadow, null) >
                                      -1
                                    : _vm.companySetting.shadow,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.companySetting.shadow,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.companySetting,
                                            "shadow",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.companySetting,
                                            "shadow",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.companySetting,
                                        "shadow",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._m(6),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column is-half label" }, [
                          _vm._v("Allow Invoice Previous Month"),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-curve p-smooth m-0 p-bigger",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.companySetting
                                        .allowInvoicePreviousMonth,
                                    expression:
                                      "companySetting.allowInvoicePreviousMonth",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.companySetting.allowInvoicePreviousMonth
                                  )
                                    ? _vm._i(
                                        _vm.companySetting
                                          .allowInvoicePreviousMonth,
                                        null
                                      ) > -1
                                    : _vm.companySetting
                                        .allowInvoicePreviousMonth,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.companySetting
                                          .allowInvoicePreviousMonth,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.companySetting,
                                            "allowInvoicePreviousMonth",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.companySetting,
                                            "allowInvoicePreviousMonth",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.companySetting,
                                        "allowInvoicePreviousMonth",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._m(7),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "columns" }, [
                        _c(
                          "div",
                          { staticClass: "column is-half label mb-0" },
                          [_vm._v("Show Driveable")]
                        ),
                        _c("div", { staticClass: "column is-half" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-curve p-smooth m-0 p-bigger",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.driveable,
                                    expression: "driveable",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.driveable)
                                    ? _vm._i(_vm.driveable, null) > -1
                                    : _vm.driveable,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.driveable,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.driveable = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.driveable = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.driveable = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._m(8),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column is-half label" }, [
                          _vm._v("Default Driveable"),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.companySetting.driveableDefault
                                  ? "Yes"
                                  : "No"
                              )
                            ),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.companySetting.driveableDefault,
                                expression: "companySetting.driveableDefault",
                              },
                            ],
                            staticClass: "switch is-rounded",
                            attrs: { id: "driveableDefault", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.companySetting.driveableDefault
                              )
                                ? _vm._i(
                                    _vm.companySetting.driveableDefault,
                                    null
                                  ) > -1
                                : _vm.companySetting.driveableDefault,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.companySetting.driveableDefault,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.companySetting,
                                        "driveableDefault",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.companySetting,
                                        "driveableDefault",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.companySetting,
                                    "driveableDefault",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("label", { attrs: { for: "driveableDefault" } }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field tile is-child" }, [
                  _vm._m(9),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.companySetting.address,
                        expression: "companySetting.address",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: { rows: "6" },
                    domProps: { value: _vm.companySetting.address },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.companySetting,
                          "address",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "field tile is-child" },
                  [
                    _vm._m(10),
                    _c(
                      "div",
                      { staticClass: "columns is-flex is-align-items-center" },
                      [
                        _c("div", { staticClass: "column is-half" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "columns is-flex is-align-items-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "column is-half label" },
                                [_vm._v("Head format")]
                              ),
                              _c("div", { staticClass: "column is-half" }, [
                                _c(
                                  "div",
                                  { staticClass: "control is-extended" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "select is-fullwidth" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.companySetting.paperType,
                                                expression:
                                                  "companySetting.paperType",
                                              },
                                            ],
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.companySetting,
                                                  "paperType",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "null",
                                                  disabled: "",
                                                },
                                              },
                                              [_vm._v("Select")]
                                            ),
                                            _vm._l(
                                              _vm.letterHeaderToPrint,
                                              function (letterHead, index) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: index,
                                                    domProps: {
                                                      value: parseInt(
                                                        letterHead.value
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(letterHead.label)
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-half label" }, [
                              _vm._v("Print on every page"),
                            ]),
                            _c("div", { staticClass: "column is-half" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth m-0 p-bigger is-two-third",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.companySetting.printLhOnEveryPage,
                                        expression:
                                          "companySetting.printLhOnEveryPage",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.companySetting.printLhOnEveryPage
                                      )
                                        ? _vm._i(
                                            _vm.companySetting
                                              .printLhOnEveryPage,
                                            null
                                          ) > -1
                                        : _vm.companySetting.printLhOnEveryPage,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.companySetting
                                              .printLhOnEveryPage,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.companySetting,
                                                "printLhOnEveryPage",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.companySetting,
                                                "printLhOnEveryPage",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.companySetting,
                                            "printLhOnEveryPage",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(11),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _vm.companySetting.paperType == "2"
                      ? _c("div", [
                          _vm.companySetting.pageHeaderImage
                            ? _c(
                                "div",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "pageHeaderImg mr-5",
                                    attrs: {
                                      src: _vm.pageHeaderImage,
                                      alt: "Company Letter Header To Print",
                                    },
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button has-text-danger",
                                      attrs: { title: "Delete" },
                                      on: { click: _vm.deletePageHeaderImage },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mso mso-24px" },
                                        [_vm._v("remove")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c("vue-dropzone", {
                                    ref: "pageHeaderImgDropzone",
                                    attrs: {
                                      id: "pageHeaderImgDropzone",
                                      options: _vm.dropzoneOptions,
                                    },
                                    on: {
                                      "vdropzone-mounted": _vm.dropzoneMounted,
                                      "vdropzone-success": _vm.dropzoneSuccess,
                                      "vdropzone-error": _vm.dropzoneError,
                                    },
                                  }),
                                ],
                                1
                              ),
                        ])
                      : _vm._e(),
                    _vm.companySetting.pageHeaderImage
                      ? _c(
                          "confirm-modal",
                          {
                            attrs: {
                              active: _vm.isConfirmModalActive,
                              "ok-text": "Yes",
                              "cancel-text": "No",
                            },
                            on: {
                              "update:active": function ($event) {
                                _vm.isConfirmModalActive = $event
                              },
                              ok: function ($event) {
                                return _vm.deleteImage(true)
                              },
                              cancel: function ($event) {
                                return _vm.deleteImage(false)
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-title" },
                                slot: "text-title",
                              },
                              [_vm._v("Delete Company Paper Head Image")]
                            ),
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-content" },
                                slot: "text-content",
                              },
                              [
                                _vm._v(
                                  " Company Paper Head Image will be deleted. Continue? "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.companySetting.paperType == "1"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Company name header"),
                              ]),
                              _c("quill-editor", {
                                model: {
                                  value: _vm.companySetting.companyNameHeader,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.companySetting,
                                      "companyNameHeader",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "companySetting.companyNameHeader",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Company page header"),
                              ]),
                              _c("quill-editor", {
                                model: {
                                  value: _vm.companySetting.pageHeader,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.companySetting,
                                      "pageHeader",
                                      $$v
                                    )
                                  },
                                  expression: "companySetting.pageHeader",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "field tile is-child" }, [
                  _vm._m(12),
                  _c("div", { staticClass: "field tabs is-boxed" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.footers, function (footer, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class: {
                              "is-active": _vm.activeFooterTabIndex === index,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.activeFooterTabIndex = index
                                  },
                                },
                              },
                              [_vm._v(_vm._s(footer.label))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.activeFooter,
                          expression: "activeFooter",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: { rows: "6" },
                      domProps: { value: _vm.activeFooter },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.activeFooter = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Preferences")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("span", { staticClass: "title is-6" }, [_vm._v("Misc")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [
        _vm._v("Default Batch Number"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [_vm._v("GST")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [
        _vm._v("External Accounting"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [_vm._v("Other Settings")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [
        _vm._v("Email Brief Letterhead"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [
        _vm._v("Letter Head To Print"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "label" }, [
      _c("label", { staticClass: "title is-6" }, [_vm._v("Footer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }